export const getBackendFieldError = (error: Record<string, string> | undefined, fieldPath: string): string | undefined => {
  return error?.[fieldPath];
};

// Collects errors from the backend error map that belong to an array section but
// have no array index — meaning the backend couldn't (or didn't) specify which item
// is at fault. These are displayed at the section level rather than on individual items.
export const getSectionErrors = (error: Record<string, string> | undefined, fieldPath: string): string[] => {
  if (!error) return [];
  const prefix = `${fieldPath}.`;
  return Object.entries(error)
    .filter(([key]) => key.startsWith(prefix) && !key.startsWith(`${fieldPath}[`))
    .map(([, message]) => message);
};

export const getFormikFieldError = (fieldError: any, fieldTouched: any): string | undefined => {
  return fieldError && fieldTouched ? fieldError : undefined;
};

export const getCombinedError = (
  error: Record<string, string> | undefined,
  fieldPath: string,
  fieldError: any,
  fieldTouched: any,
): string | undefined => {
  return getBackendFieldError(error, fieldPath) ?? getFormikFieldError(fieldError, fieldTouched);
};

export const hasFieldError = (
  error: Record<string, string> | undefined,
  fieldPath: string,
  fieldError: any,
  fieldTouched: any,
): boolean => {
  return Boolean(getBackendFieldError(error, fieldPath) || getFormikFieldError(fieldError, fieldTouched));
};

export const createFormikChangeHandler = <T extends unknown>(
  updateFn: (value: T) => void,
  clearErrors?: () => void,
): ((value: T) => void) => {
  return (value: T) => {
    clearErrors?.();
    setTimeout(() => updateFn(value), 0);
  };
};
